module.exports = __webpack_public_path__ + "img/img_bodytype_belt.0723f6a3.png";